import React from "react";
import SignBuilder from "./SignBuilder";

export default function Corflute() {
  return <SignBuilder product="corflute" />;
}
